import { alpha, Button, CircularProgress, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";


export default function TextButton({
  text,
  preIcon = null,
  type = "button",
  fullWidth = true,
  onClick = () => { },
  disabled = false,
  isSubmitting = false,
  size = "medium",
  sx,
}) {
  const { mode } = useColorScheme();
  const currentMode = mode || "light";
  return (
    <Button
      onClick={isSubmitting ? () => { } : onClick}
      size={size}
      variant="contained"
      startIcon={preIcon}
      disabled={disabled}
      fullWidth={fullWidth}
      type={type}
      sx={{
        backgroundColor: "transparent",
        color: Constants.Colors[currentMode].accent,
        borderRadius: "6px",
        boxShadow: "none",
        textTransform: "none",
        fontWeight: Constants.Styles.fontWeight.semiBold,
        p: 0,
        m: 0,
        "&:hover": {
          backgroundColor: alpha(Constants.Colors[currentMode].accent, 1),
          color: alpha(Constants.Colors[currentMode].accentForeground, 1),
        },
        ...sx,
      }}
    >
      {isSubmitting ? <CircularProgress color="success" size={20} /> : text}
    </Button>
  );
}